<template>
  <div class="initial:w-full">
    <label
      v-if="label"
      :id="uniqueLabelId"
      :for="uniqueElementId"
      :class="[
        'inline-block relative text-[#161616]',
        $slots.description ? 'initial:mb-1' : 'initial:mb-2',
        labelClass,
      ]"
    >
      <span>{{ label }}</span>
      <span v-if="required" class="text-[#E2011C]"> * </span>
      <span v-if="labelSuffix" class="text-jva-blue-400 ml-2">{{ labelSuffix }}</span>
      <slot name="afterLabel" />
    </label>

    <div v-if="$slots.description" class="mb-2">
      <slot name="description" :descriptionId="uniqueDescriptionId" />
    </div>

    <slot
      :id="uniqueElementId"
      :required="required"
      :error="error"
      :ariaLabelledby="uniqueLabelId"
      :ariaDescribedby="ariaDescribedby"
      :ariaErrormessage="ariaErrormessage"
    />

    <BaseFormInfo v-if="info && !error" :id="uniqueInfoId">{{ info }}</BaseFormInfo>
    <BaseFormError v-if="error" :id="uniqueErrorId" aria-live="polite">
      {{ error }}
    </BaseFormError>
    <BaseFormSuccess v-if="success" :id="uniqueSuccessId" aria-live="polite">
      {{ success }}
    </BaseFormSuccess>

    <slot name="bottom" />
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    htmlFor: { type: String, default: null }, // @todo: rename to labelFor
    info: { type: String, default: null },
    error: { type: String, default: null },
    success: { type: String, default: null },
    label: { type: String, default: null },
    labelSuffix: { type: String, default: null },
    labelClass: { type: String, default: null },
    required: { type: Boolean, default: false },
  },
  setup() {
    return {
      uuid: useId(),
    }
  },
  computed: {
    uniqueElementId() {
      // @todo: Uncomment this and refactor (retrieve it via <template #default>).
      // return this.htmlFor ? `${this.htmlFor}_${this.uuid}` : null
      return this.htmlFor
    },
    uniqueLabelId() {
      return this.label ? `label_${this.uuid}` : null
    },
    uniqueDescriptionId() {
      return this.$slots.description ? `description_${this.uuid}` : null
    },
    uniqueInfoId() {
      return this.info ? `info_${this.uuid}` : null
    },
    uniqueErrorId() {
      return this.error ? `error_${this.uuid}` : null
    },
    uniqueSuccessId() {
      return this.success ? `success_${this.uuid}` : null
    },
    ariaDescribedby() {
      const describedByIds = [
        this.uniqueDescriptionId,
        this.uniqueInfoId,
        this.uniqueSuccessId,
      ].filter((id) => id)
      return describedByIds.length > 0 ? describedByIds.join(' ') : null
    },
    ariaErrormessage() {
      return this.uniqueErrorId
    },
  },
})
</script>
